const styles = {
  link: 'text-body1 text-red-medium tesn:text-esn-primary tesn:hover:text-esn-primary-light teair:text-air-mediumBlue teair:hover:text-air-skyBlue underline hover:text-red font-semibold',
};

export default styles;
